// extracted by mini-css-extract-plugin
export var container = "styles-module--container--205f1";
export var soundBtn = "styles-module--soundBtn--7f29a";
export var svg = "styles-module--svg--41650";
export var video = "styles-module--video--1d562";